module.exports = __webpack_public_path__ + "static/roofbanner-cefdb123b87ca7e9f0305234788ce59f.jpg";